import { TimeIcon } from "components/Icons";
import { classNames as cn } from "tools/ui";

function getEntryRange(entry) {
  if (entry && typeof entry === "object") {
    if (entry.range_type === "dates") {
      return { start: entry.start_date || "", end: entry.end_date || "" };
    }
    return { start: entry.start || "", end: entry.end || "" };
  }
  return { start: "", end: "" };
}

function CardEvents({ entries, readOnly, onRemove }) {
  if (!entries || entries.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-3">
      {entries.map((entry) => {
        const times = getEntryRange(entry);

        return (
          <button
            key={entry.id ?? entry.value}
            type="button"
            disabled={readOnly}
            className={cn(
              "flex items-center gap-x-2 py-2 px-3 rounded-xl text-sm text-center transition-all",
              "border bg-sky-100 border-sky-300 text-sky-800 font-medium shadow-2xs",
            )}
          >
            {entry.value}
            {(times.start || times.end) && (
              <span className="text-xs text-sky-600 whitespace-nowrap">
                {times.start || "--"} - {times.end || "--"}
              </span>
            )}

            {!readOnly && (
              <span
                className="text-md text-sky-500 ml-1 cursor-pointer hover:text-rose-600 active:scale-95"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove?.(entry);
                }}
                title="Quitar novedad"
              >
                ✕
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default CardEvents;
